import {Component, Input, ViewChild} from "@angular/core";
import {Store} from "@ngrx/store";
import {TransferDocumentsGroupComponent} from "./transfer-documents-group/transfer-documents-group.component";
import {Order} from "../../../store/state/order.state";
import {AppState} from "../../../store/state/app.state";
import {OrderActions} from "../../../store/actions/order.actions";

@Component({
    selector: 'transfer-documents',
    templateUrl: './transfer-documents.template.html',
    standalone: false
})
export class TransferDocumentsComponent {

	@Input() blockInputs: boolean = false;
	@Input() order: Order;

	@ViewChild('certificateDocuments', {static: false}) certificateDocuments: TransferDocumentsGroupComponent;
	@ViewChild('reportDocuments', {static: false}) reportDocuments: TransferDocumentsGroupComponent;

	constructor(private store: Store<AppState>) {
	}

	triggerValidations() {
		this.certificateDocuments.triggerValidations();
		this.reportDocuments.triggerValidations();
	}

	isFormValid(): boolean {
		return this.certificateDocuments.isFormValid() && this.reportDocuments.isFormValid();
	}

	areFilesUploaded(): boolean {
		return this.certificateDocuments.areFilesUploaded() && this.reportDocuments.areFilesUploaded();
	}

	uploadDocuments() {
		this.store.dispatch(OrderActions.UPLOAD_DOCUMENTS({
			correlationId: this.order.orderCorrelationId,
			certificateDocuments: this.certificateDocuments.files,
			reportDocuments: this.reportDocuments.files
		}));
	}

	navigateToValidationError() {
		if (!this.certificateDocuments.isFormValid()) {
			this.certificateDocuments.navigateToValidationError();
		} else {
			this.reportDocuments.navigateToValidationError()
		}
	}
}
